import { createSlice } from "@reduxjs/toolkit";

export const mockAdoptSiteDevices = [
  {
    "code": 1,
    "macAddress": "3c:33:32:14:ab:00",
    "message": "Failure"
  },
  {
    "code": 0,
    "macAddress": "bc:22:28:d7:64:80",
    "message": "Success"
  },
  {
    "code": 0,
    "macAddress": "00:25:35:89:22:01",
    "message": "Success"
  },
  {
    "code": 1,
    "macAddress": "3c:33:32:14:a2:00",
    "message": "Failure"
  },
  {
    "code": 0,
    "macAddress": "bc:22:28:72:0f:70",
    "message": "Success"
  }
];

export const adoptSiteSlice = createSlice({
  name: "onPremAdoptSiteDevices",
  initialState: {
    resource: 'adopt',
    data: [...mockAdoptSiteDevices],
  },
});

export default adoptSiteSlice.reducer;